export const capitalize = (value) => {
  return typeof value === 'string'
    ? value.charAt(0).toUpperCase() + value.toLowerCase().slice(1)
    : value
}
